import { render } from "./FurniturePost.vue?vue&type=template&id=e1b191e6&scoped=true"
import script from "./FurniturePost.vue?vue&type=script&lang=js"
export * from "./FurniturePost.vue?vue&type=script&lang=js"

import "./FurniturePost.vue?vue&type=style&index=0&id=e1b191e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1b191e6"]])

export default __exports__